import { render, staticRenderFns } from "./MilestoneSetModal.vue?vue&type=template&id=cf68bd8a&"
import script from "./MilestoneSetModal.vue?vue&type=script&lang=js&"
export * from "./MilestoneSetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports